import IndustryPageTemplate from "./IndustryPageTemplate";
import { dentistsData } from "@/data/dentists";

export default function DentistsPage() {
  return <IndustryPageTemplate data={dentistsData} />;
}
